import clsx from "clsx";
import { Mail, Phone } from "lucide-react";

import { Button } from "@/src_new/shared/components";

type AuthMethodTabsProps = {
  activeTab: "email" | "phone";
  onChange: (value: "email" | "phone") => void;
};

const tabBaseClass =
  "flex-1 rounded-lg border border-transparent px-4 py-2.5 text-sm font-medium transition-all duration-200";

export default function AuthMethodTabs({ activeTab, onChange }: AuthMethodTabsProps) {
  return (
    <div className="mb-5 flex items-center rounded-2xl border border-theme-border bg-theme-surface-soft p-1.5 shadow-xs gap-2">
      <Button
        type="button"
        onClick={() => onChange("email")}
        className={clsx(
          tabBaseClass,
          activeTab === "email"
            ? "bg-theme-primary text-theme-text-inverse shadow-sm"
            : "bg-transparent text-theme-text-muted hover:bg-theme-surface hover:text-theme-text"
        )}
      >
        <span className="flex items-center justify-center gap-2">
          <Mail size={16} />
          Email
        </span>
      </Button>

      <Button
        type="button"
        onClick={() => onChange("phone")}
        className={clsx(
          tabBaseClass,
          activeTab === "phone"
            ? "bg-theme-primary text-theme-text-inverse shadow-sm"
            : "bg-transparent text-theme-text-muted hover:bg-theme-surface hover:text-theme-text"
        )}
      >
        <span className="flex items-center justify-center gap-2">
          <Phone size={16} />
          Phone
        </span>
      </Button>
    </div>
  );
}
